<template>
     <div class="container" v-title="'修改/删除参赛人员信息'">
         <Navigation-bar></Navigation-bar>
         <div class="container_content" v-show="pageShow">
             <div id="GroupPersonnel">
                <Title title="修改/删除参赛人员信息" :subtitle="group.name"></Title>
                <div class="group_hint" v-if="AuditRejectReason">
                    <div>
                        <YD-image src="icon/icon_提示_红色_2"></YD-image>
                        <span>组委会审核不通过</span>
                    </div>
                    <p>{{AuditRejectReason}}</p>
                </div>
                <div id="member_list">
                    <ul>
                        <li v-for="(item,index) in member.list" :key="index" 
                            @click="lookInfo(item)" 
                            :class="{'error': (item.ImpeachReason)}">
                            <div class="member_content">
                                <div class="member_img">
                                    <img :src="getUserPhoto(item)">
                                </div>
                                <div class="member_info">
                                    <div class="member_name">
                                        <span>{{item.Name}}</span>
                                        <template v-if="item.EnrollRoleList && item.EnrollRoleList.length > 0">
                                            <template v-for="(roleItem, roleIndex) in item.EnrollRoleList">
                                                <i c1 :key="roleIndex" v-if="roleItem.RoleId != item.AthleteRoleId">{{roleItem.RoleName}}</i>
                                                <i c2 :key="roleIndex" v-else>{{roleItem.RoleName}}</i>
                                            </template>
                                        </template>
                                    </div>
                                    <div class="member_group" v-if="item.IdentityNo">{{IDType.getInfo(item.IdentityType, 'forShort')}} {{item.IdentityNo}}</div>
                                    <div class="member_group" v-else>
                                        <span v-if="item.Gender">性别:{{item.Gender == 1 ? "男" : "女"}}  </span>
                                        <span v-if="item.Birthday"><span v-if="item.Gender"> | </span>出生日期:{{item.Birthday | dateFormat('yyyy年MM月dd日')}}</span>
                                    </div>
                                </div>
                                <YD-image src="icon/card_delete_灰色" class="delete" @click.stop.native="deleteMember(item)"></YD-image>
                            </div>
                            <div class="member_hint" v-if="item.ImpeachReason">
                                <div>
                                    <YD-image src="icon/icon_提示_红色_2"></YD-image>
                                    <span>运动员被举报</span>
                                </div>
                                <p>{{item.ImpeachReason}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
             </div>
         </div>
         <div class="bottom_operation" v-show="pageShow">
            <div v-if="this.group.type == 3">
                <button v-href="`/Enroll/OneselfEnroll/TeammateInfo?subLeagueId=${this.subLeagueId}&groupId=${this.group.id}`" v-if="!IsAddTeammate && !IsAgentEnroll">添加队友</button>
                <button class="disabled" v-else>添加队友</button>
            </div>
            <div v-else></div>
            <div>
                <button @click="goSubmit()">完成</button>
            </div>
         </div>
     </div>
</template>
<script>
import * as IDType from '@js/enum/IDType'
import {
    GetMyIndividualEnrollOneGroupDetail,
    IndividualEnrollDelDoubleMate,
    CancelIndividualEnrollGroup
} from '@/api';

const watch = {};
const keys = ['ONESELF_ENROLL_MY_INFO', 'ONESELF_ENROLL_TEAMMATE_INFO', 'ENROLL_UPDATE_PHONE'];
for(let key of keys){
    watch['$store.state.monitor.'+key] = {
        deep: true,
        handler(){
            this.getGroup();
        }
    }
}
export default {
    name:"UpdatePersonnel",
    data(){
        var subLeagueId = +this.$route.query.subLeagueId,
            groupId = +this.$route.query.groupId;
        return{
            subLeagueId: isNaN(subLeagueId) ? 0 : subLeagueId,
            IDType,
            pageShow: false,
            group:{
                id: isNaN(groupId) ? 0 : groupId,
                name: '',
                type: 0
            },
            member:{
                list:[],
                isMe: true
            },
            IsAddTeammate: false,
            IsAgentEnroll: false,
            EnrollStatus: 0,
            AuditRejectReason: '',
            isGetData: false
        }
    },
    computed:{
		portraitUnknown(){
			return require(`@images/portrait_unknown@3x.png`);
		},
		portraitMan(){
			return require(`@images/肖像_男@3x.png`);
		},
		portraitWoman(){
			return require(`@images/肖像_女@3x.png`);
		},
    },
    watch:{
        ...watch
    },
    created(){
        this.getGroup();
    },
    methods:{
		getUserPhoto(UserInfo){
			if(UserInfo.PhotolUrl){
				return UserInfo.PhotolUrl;
			}else if(UserInfo.Gender == 1){
				return this.portraitMan;
			}else if(UserInfo.Gender == 2){
				return this.portraitWoman;
			}
			return this.portraitUnknown;
		},
        getGroup(){
            if(this.isGetData)return;
            this.isGetData = true;
            GetMyIndividualEnrollOneGroupDetail({
                LeagueId: this.subLeagueId,
                GroupId: this.group.id
            }).then(data=>{
                this.isGetData = false;
                if(data.Code == 0){
                    this.pageShow = true;
                    let {
                        GroupInfo,
                        UserList,
                        IsAddTeammate,
                        IsAgentEnroll,
                        EnrollStatus,
                        AuditRejectReason
                    } = data.EnrollGroup;
                    this.group.name = GroupInfo.Name;
                    this.group.type = GroupInfo.GroupType;
                    this.$set(this.member, 'list', UserList);
                    this.IsAddTeammate = IsAddTeammate;
                    this.IsAgentEnroll = IsAgentEnroll;
                    this.EnrollStatus = EnrollStatus;
                    this.AuditRejectReason = AuditRejectReason;
                }else if(data.Code == 3928){
                    this.$Prompt({
                        title: '温馨提示',
                        message: '您已不再报名该组别',
                        confirmText: '知道了'
                    }).then(()=>{
                        this.$navigation.back();
                    })
                }
            }).catch(()=>{
                this.isGetData = false;
            })
        },
        //删除队友
        deleteMember(obj){
			if(obj.IsMe){
				let title = '温馨提示',
					message = '您确定要取消该组别的报名吗？';
				if(this.IsAgentEnroll){
					title = '该组别由队友代报名';
					message = '操作后，队友不再与您配对，TA可以更换其他人配对报名该组别。是否继续？';
				}
                this.$Prompt({
                    title,
                    message,
                    showCancel: true
                }).then(confirm=>{
                    if(!confirm) return;
                    CancelIndividualEnrollGroup({
                        LeagueId: this.subLeagueId,
                        GroupId: this.group.id
                    }).then(data=>{
                        if(data.Code == 0){
                            this.$Toast.success('报名取消成功');
                            this.$store.commit('monitor/ONESELF_ENROLL_GROUP_CANCEL');
                            setTimeout(()=>{
                                this.$navigation.back();
                            },1000)
                        }
                    })
                })
            }else{
                if(this.IsAgentEnroll){
                    this.$Toast.warning('队友代报名，请联系队友删除');
                }else{
                    this.$Prompt({
                        title: '温馨提示',
                        message: `将删除该队友，请确认操作`,
                        showCancel: true
                    }).then(confirm=>{
                        if(!confirm) return;
                        IndividualEnrollDelDoubleMate({
                            LeagueId: this.subLeagueId,
                            GroupId: this.group.id
                        }).then(data=>{
                            if(data.Code == 0){
                                this.$store.commit('monitor/ONESELF_ENROLL_DOUBLE_DELETE');
                                this.getGroup();
                            }
                        })
                    })
                }
            }
        },
        //查看队友信息
        lookInfo(obj){
            if(obj.IsMe){
                this.$navigation.go(`/Enroll/OneselfEnroll/MyInfo?subLeagueId=${this.subLeagueId}`);
            }else{
                this.$navigation.go(`/Enroll/OneselfEnroll/TeammateInfo?subLeagueId=${this.subLeagueId}&groupId=${this.group.id}&userId=${obj.UserId}`);
            }
        },
        //完成
        goSubmit(){
            this.$navigation.back();
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@assets/scss/TeamPersonnel.scss';
.bottom_operation{
    div button.disabled{
        color: #999999;
    }
    div:nth-of-type(2) button{
        background: #1B1C1E;
        color: #FFFFFF;
    }
}
.group_hint{
    width: calc(100% - 80px);
    height: auto;
    margin: 0 auto;
    margin-bottom: 24px;
    padding: 8px 26px 16px 40px ;
    box-sizing: border-box;
    background: #FEF7F4;
    border-radius: 20px;
    div{
        height: 44px;
        display: flex;
        align-items: center;
        font-size: 26px;
        color: #FF5F2A;
        font-weight: 500;
        img{
            width: 38px;
            height: 38px;
            margin-right: 8px;
        }
    }
    p{
        font-size: 26px;
        color: #F0815C;
        line-height: 40px;
        font-weight: 400;
        margin-top: 4px;
    }
}
</style>